<!--
 * @Desc: 
 * @Author: may.li
 * @Date: 2023-05-10 15:17:15
 * @LastEditors: may.li
 * @LastEditTime: 2023-05-12 16:14:32
-->
<template>
  <section class="app-main">
    <transition name="fade-transform" mode="out-in">
      <keep-alive :include="cachedViews">
        <router-view :key="key" />
      </keep-alive>
    </transition>
  </section>
</template>

<script>
export default {
  name: 'AppMain',
  computed: {
    cachedViews() {
      return this.$store.state.tagsView.cachedViews
    },
    key() {
      return this.$route.fullPath
    }
  }
}
</script>

<style lang="scss" scoped>
.app-main {
  /* 64= navbar  64  */
  min-height: calc(100vh - 64px);
  width: 100%;
  position: relative;
  overflow: hidden;
  background: #f1f6f9;
}

.fixed-header+.app-main {
  padding-top: 64px;
}

.hasTagsView {
  .app-main {
    /* 98 = navbar + tags-view = 64 + 34 */
    min-height: calc(100vh - 98px);
  }

  .fixed-header+.app-main {
    padding-top: 98px;
  }
}
</style>

